import { formSet } from "../gvc/testNewForm/utils";
import { BillingAccountCreateInput, BillingAccountDetailInput } from "./create/input";

export function getValidatorCreate(id: string) {
  return async function validator(v: BillingAccountCreateInput): Promise<boolean | null> {
    // setup
    formSet(id, `meta.valid`, false);
    formSet(id, `meta.validating`, true);
    formSet(id, `errors`, {});
    formSet(id, `warnings`, {});

    const e: Partial<Record<string, { message: string }>> = {};
    const w: Partial<Record<string, { message: string }>> = {};

    function setError(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      e[path] = { message: message };
    }

    function setWarning(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      const currentWarning = w[path];
      if (currentWarning) {
        return;
      }
      w[path] = { message: message };
    }

    // setup end

    if (v.meta.formStep === "info") {
      if (!v.account.accountName) {
        setError(`account.accountName`, `Account Name is required`);
      }
      if (!v.account.fullName) {
        setError(`account.fullName`, `Full Name is required`);
      }
      if (!v.account.company) {
        setError(`account.company`, `Company is required`);
      }
      if (!v.account.jobTitle) {
        setError(`account.jobTitle`, `Job Title is required`);
      }
      if (!v.account.phone) {
        setError(`account.phone`, `Phone is required`);
      } else {
        if (v.account.phone.length < 10) {
          setError(`account.phone`, `Phone must be at least 10 characters`);
        }
      }

      if (v.account.tou === false) {
        setError(`account.tou`, `Terms of Use needs to be accepted. Please read and accept.`);
      }
    }

    if (v.meta.formStep === "address") {
      if (!v.address.country) {
        setError(`address.country`, `Country is required`);
      }
      if (!v.address.state && v.address.country === "United States") {
        setError(`address.state`, `State is required`);
      }
      if (!v.address.city) {
        setError(`address.city`, `City is required`);
      }
      if (!v.address.address1) {
        setError(`address.address1`, `Address Line 1 is required`);
      }
      if (!v.address.postalCode) {
        setError(`address.postalCode`, `Postal Code is required`);
      }
    }

    try {
      // setup
      for (const path of Object.keys(e)) {
        const value = e[path];
        formSet(id, `errors.${path}`, value);
      }
      for (const path of Object.keys(w)) {
        const value = w[path];
        formSet(id, `warnings.${path}`, value);
      }

      const hasErrors = Object.keys(e).length > 0;

      formSet(id, `meta.valid`, !hasErrors);
      formSet(id, `meta.validating`, false);

      return hasErrors;
    } catch (e) {
      formSet(id, `errors`, { root: e.message });
      return true;
    }
  };
}

export function getValidatorDetail(id: string) {
  return async function validator(v: BillingAccountDetailInput): Promise<boolean | null> {
    // setup
    formSet(id, `meta.valid`, false);
    formSet(id, `meta.validating`, true);
    formSet(id, `errors`, {});
    formSet(id, `warnings`, {});

    const e: Partial<Record<string, { message: string }>> = {};
    const w: Partial<Record<string, { message: string }>> = {};

    function setError(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      e[path] = { message: message };
    }

    function setWarning(path: string, message: string) {
      const currentError = e[path];
      if (currentError) {
        return;
      }
      const currentWarning = w[path];
      if (currentWarning) {
        return;
      }
      w[path] = { message: message };
    }

    // setup end

    if (!v.account.accountName) {
      setError(`account.accountName`, `Account Name is required`);
    }
    if (!v.account.fullName) {
      setError(`account.fullName`, `Full Name is required`);
    }
    if (!v.account.company) {
      setError(`account.company`, `Company is required`);
    }
    if (!v.account.phone) {
      setError(`account.phone`, `Phone is required`);
    } else {
      if (v.account.phone.length < 10) {
        setError(`account.phone`, `Phone must be at least 10 characters`);
      }
    }

    if (!v.address.country) {
      setError(`address.country`, `Country is required`);
    }
    if (!v.address.state && v.address.country === "United States") {
      setError(`address.state`, `State is required`);
    }
    if (!v.address.city) {
      setError(`address.city`, `City is required`);
    }
    if (!v.address.address1) {
      setError(`address.address1`, `Address Line 1 is required`);
    }
    if (!v.address.postalCode) {
      setError(`address.postalCode`, `Postal Code is required`);
    }

    try {
      // setup
      for (const path of Object.keys(e)) {
        const value = e[path];
        formSet(id, `errors.${path}`, value);
      }
      for (const path of Object.keys(w)) {
        const value = w[path];
        formSet(id, `warnings.${path}`, value);
      }

      const hasErrors = Object.keys(e).length > 0;

      formSet(id, `meta.valid`, !hasErrors);
      formSet(id, `meta.validating`, false);

      return hasErrors;
    } catch (e) {
      formSet(id, `errors`, { root: e.message });
      return true;
    }
  };
}
